import React, { useContext } from 'react'

import { Button } from '@components/Button'
import { AstuteContext } from '../../context'

export const Index = () => {
  const {
    actions: { navigateToForm }
  } = useContext(AstuteContext)

  return (
    <>
      <p className='astute-credentials-set'>You have set your Astute credentials. If you would like to update them, click 'Edit' below</p>
      <div className='flex flex-end'>
        <Button
          primary
          trackAs='Astute credentials: Edit'
          onClick={navigateToForm}
        >
          Edit
        </Button>
      </div>
    </>
  )

}
